import { observer } from 'mobx-react';
import { ElementType, FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Redirect3dSecure, {
  IContinueButton,
  IRedirect3dSecure,
} from '@components/modals/Redirect3dSecure';

import useStore from '@hooks/useStore';

export interface IShowModal {
  component: ElementType;
  props: any;
}

export interface IIframeHandlerProps {
  iframeCode: string;
  showModal({ component, props }: IShowModal): void;
  closeModal: () => void;
  callback: () => void;
  continueButton: IContinueButton;
  acsURL: string;
}

const IframeHandler: FC<IIframeHandlerProps> = ({
  iframeCode,
  callback,
  showModal,
  closeModal,
  continueButton,
  acsURL,
}) => {
  const DELAY_TO_EXECUTE_CALLBACK = 10000;
  const { fiserv, links } = useStore();
  const { t } = useTranslation();

  const modalProps: IRedirect3dSecure = useMemo(() => {
    return {
      callback,
      amount: links.paymentLink.total,
      delay: !acsURL ? DELAY_TO_EXECUTE_CALLBACK : 3000,
      waitingMessage: t('checkoutScreen.payment.methods.card.secure3d.processing'),
      onClose: closeModal,
      continueButton,
    } as IRedirect3dSecure;
  }, [continueButton]);

  useEffect(() => {
    if (iframeCode) {
      // execute with Frictionless with validation or Challenge 3DSecure with validation
      showModal({
        component: Redirect3dSecure,
        props: modalProps,
      });
    }
  }, [iframeCode, modalProps]);

  useEffect(() => {
    if (iframeCode) {
      fiserv.setIsSendingPayment(true);
      // submit form embed from iframe
      (document.getElementById('tdsMmethodForm') as HTMLFormElement).submit();
    }
  }, [iframeCode]);

  useEffect(() => {
    if (!iframeCode && acsURL) {
      // execute only with Challenge 3DSecure without validation
      showModal({
        component: Redirect3dSecure,
        props: modalProps,
      });
    }
  }, [iframeCode, acsURL, modalProps]);

  if (iframeCode) {
    return <div id="iframeFromFiserv" dangerouslySetInnerHTML={{ __html: iframeCode }} />;
  }

  return null;
};

export default observer(IframeHandler);
